  <template>
  <div>
    <v-card>
      <v-card-title primary-title>
        <h3 class="headline mb-0">Citas disponibles con: {{quoteData.name_as}}</h3>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-card-title>
        <div class="text-xs-center" v-if="quoteData.assistance_type == 'BOTH'">
          <v-select
            v-model="assistance_type"
            :items="assistanceTypes"
            :label="$t('event.create-form.assistance_type')"
            item-text="label"
            item-value="value"
          ></v-select>
        </div>
        <div class="text-xs-center" v-else>{{assistance_types[quoteData.assistance_type]}}</div>
      </v-card-title>
      <v-card-text>
        <v-layout row wrap justify-center>
          <v-flex xs12>
            <v-data-table
              :headers="headers"
              :items="availableSchedules"
              class="elevation-1"
              :search="search"
            >
              <template slot="items" slot-scope="props">
                <td class="text-xs-center">{{ props.item.schedule_start_date }} {{ props.item.schedule_start_time | formatHour }}</td>
                <td class="text-xs-center green--text"  v-if="props.item.status == 0">Disponible</td>
                <td class="text-xs-center red--text" v-else>Asignada</td>
                <td class="text-xs-center">
                  <v-btn
                    color="primary"
                    v-if="props.item.status == 0"
                    @click="takeSchedule(props.item)"
                    :loading="loading_btn == props.item.id"
                    :disabled="loading_btn == props.item.id || !userCanSchedule"
                  >
                    Asignar Cita
                  </v-btn>

                  <v-btn
                    color="error"
                    v-if="props.item.status == 1 && props.item.user_id == user.id"
                    @click="cancelSchedule(props.item)"
                    :loading="loading_btn == props.item.id"
                    :disabled="loading_btn == props.item.id"
                  >
                    Cancelar
                  </v-btn>
                </td>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
  import axios from 'axios'
  import formatHour from "../../libs/filter"
  export default {
    name: 'available-schedule-view',
    props: {
      responsible_id: {
        type: [Number],
        required: false,
        default: null
      },
      entry_id: {
        type: [Number],
        required: false,
        default: null
      },
    },
    data() {
      return {
        responsible_appointment: '',
        headers: [
          { text: 'Fecha y hora inicio', align: 'center', value: 'schedule_start_date' },
          { text: 'Estado', align: 'center', value: 'status' },
          { text: 'Acción', align: 'center', value: 'id', sortable: false }
        ],
        availableSchedules: [],
        user: {},
        quoteData: {},
        is_responsible: false,
        loading_btn: 0,
        userCanSchedule: true,
        search: '',
        assistance_type: '',
        assistance_types: {
          BOTH: 'Virtual y Presencial',
          ONLINE: 'Virtual',
          FACEFACE: 'Presencial'
        },
        assistanceTypes: [
          { label: 'Presencial', value: 'FACEFACE' },
          { label: 'Virtual', value: 'ONLINE' },
        ],
        quote_id: null,
      }
    },
    created () {
      if (this.responsible_id) {
        this.responsible_appointment = this.responsible_id
      } else {
        this.responsible_appointment = this.$route.params.id
      }
      this.init(this.responsible_appointment);
    },
    watch: {
      responsible_id() {
        this.responsible_appointment = this.responsible_id
        this.init(this.responsible_appointment);
      },
    },
    methods: {
      init(responsible_appointment) {
        axios.get(`/api/schedule/show/available/${responsible_appointment}`)
          .then(resp => {
            //console.log(resp)
            this.availableSchedules = resp.data.scheduleData.filter(data => {
              if (data.status == 1 && data.user_id != resp.data.user.id) {
                return false
              }
              return true
            })
            this.user = resp.data.user
            this.userCanSchedule = resp.data.userCanSchedule
          })
          .catch(err => console.log(err))

        axios.get(`/api/qoutes/get/${responsible_appointment}`)
          .then(resp => {
            this.quoteData = resp.data.data
            this.is_responsible = resp.data.is_responsible
          })
          .catch(error=>{

        });
      },
      takeSchedule(event) {
        if (this.quoteData.assistance_type == 'BOTH') {
          if (!this.assistance_type || this.assistance_type == '') {
            this.$store.dispatch('responseMessage', {
              type: 'warning',
              text: this.$t('Por favor selecciona el tipo de cita que deseas tomar.'),
              title: this.$t('event.create-form.stored-ok-title'),
              modal: true
            })
            return;
          }
        }
        if (this.guest) {
          this.dialog =  true;
        } else {
          this.loading_btn = event.id
          let data = {
            quoteName: this.quoteData.description,
            quotes_id: this.quoteData.quotes_id,
            schedule_id: event.id,
            name: this.user.name,
            email: this.user.email,
            guest: false,
            assistance_type: this.assistance_type,
            admissions: true
          }
          axios.post('/api/take/schedule', data)
            .then(resp => {
              this.loading_btn = 0
              this.init(this.responsible_appointment);
              if(resp.status > 0){
                this.$store.dispatch('responseMessage', {
                  type: 'success',
                  text: this.$t('Cita tomada con éxito'),
                  title: this.$t('event.create-form.stored-ok-title'),
                  modal: true
                })
                if ( this.entry_id ) {
                  const payload = {
                    entry_id : this.entry_id,
                    step : 0
                  }
                  axios.put('/api/admissions/update_step', payload)
                    .then(resp => {
                      if (resp.status === 200) {
                        this.$store.dispatch('responseMessage', {
                            type: 'success',
                            title: 'Admisiones',
                            text: 'Gracias, hemos recibido su formulario.',
                            modal: false
                        })
                        setTimeout(function() {
                          window.location = "complete-info";
                        }, 3000);
                      }
                    })
                }
              } else {
                this.$store.dispatch('responseMessage', {
                  type: 'warning',
                  text: this.$t('La Cita ya fue tomada por otro usuario.'),
                  title: this.$t('event.create-form.stored-ok-title'),
                  modal: true
                })
              }
            })
            .catch(error => {
              this.loading_btn = 0
              this.$store.dispatch('responseMessage', {
                type: 'error',
                text: this.$t('Se presento un error al tomar la cita, intente de nuevo'),
                title: this.$t('Error'),
                modal: true
              })
            })
        }
      },
      cancelSchedule(item){
        axios.post('/api/schedule/cancel', {
          id: item.id,
          quoteName: this.quoteData.description,
          quotes_id: this.quoteData.quotes_id
        })
          .then(resp=>{
            if (resp.data.length < 1){
              this.init(this.responsible_appointment);
              this.$store.dispatch('responseMessage', {
                type: 'success',
                text: this.$t('Una de las personas no tiene correo electrónico, por favor notifique por otro medio'),
                title: this.$t('event.create-form.stored-ok-title'),
                modal: true
              })
            } else{
              this.init(this.responsible_appointment);
              this.$store.dispatch('responseMessage', {
                type: 'success',
                text: this.$t('Cita cancelada con éxito'),
                title: this.$t('event.create-form.stored-ok-title'),
                modal: true
              })
            }
          }).catch(erro => console.log(erro))
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/shedule/AvailableSchedules.vue